import english from '../en/cinema';

export default {
  ...english,
  cinema_referral: "Dapatkan dengan Berbagi",
  cinema_referralDesc: "Undang teman dengan tautan pribadi Anda dan dapatkan hadiah",
  cinema_referralLinkTitle: "Tautan Referral Saya",
  cinema_referralLinkDesc: "Pendaftaran baru melalui tautan ini akan diatribusikan kepada Anda",
  cinema_referralRulesTitle: "Aturan Referral",
  cinema_referralRulesCoins: "Ketika seorang teman mendaftar melalui tautan referral Anda, Anda dapat menerima hadiah koin. Koin hanya dapat digunakan untuk menonton konten di platform dan tidak dapat ditukar dengan uang tunai atau ditarik.",
  cinema_referralRulesCommission: "Ketika seorang teman melakukan isi ulang, Anda dapat memperoleh komisi sesuai aturan yang berlaku. Hanya komisi isi ulang yang dapat ditarik; setelah mencapai ¥100, Anda dapat mengajukan penarikan USDT.",
  cinema_copyLink: "Salin tautan",
  cinema_inviteCodeLabel: "Kode referral",
  cinema_inviteRuleTitle: "Hadiah referral",
  cinema_inviteRuleNormal: "Anggota mendapatkan 20 koin untuk setiap pendaftaran yang berhasil. Hadiah tercatat dalam riwayat koin.",
  cinema_distributorOverview: "Ikhtisar distributor",
  cinema_availableCommission: "Tersedia",
  cinema_totalCommission: "Total komisi",
  cinema_pendingWithdrawal: "Penarikan tertunda",
  cinema_withdrawnAmount: "Telah ditarik",
  cinema_firstLevelRate: "Tarif level 1",
  cinema_secondLevelRate: "Tarif level 2",
  cinema_todayBrowse: "Tampilan",
  cinema_todayRegister: "Pendaftaran",
  cinema_todayRecharge: "Isi ulang",
  cinema_todayRechargeAmount: "Jumlah isi ulang",
  cinema_commissionAmount: "Komisi",
  cinema_registerDetails: "Pendaftaran",
  cinema_rechargeDetails: "Isi ulang",
  cinema_inviteRewards: "Hadiah referral",
  cinema_goWithdraw: "Penarikan",
  cinema_noReferralData: "Belum ada data referral",
  cinema_referralLoadFailed: "Tidak dapat memuat data referral. Silakan coba lagi.",
  cinema_loginToPromote: "Masuk untuk membuat tautan referral Anda",
  cinema_totalEarnings: "Total Penghasilan",
  cinema_withdrawable: "Dapat ditarik",
  cinema_frozen: "Dibekukan",
  cinema_invitedCount: "Diundang",
  cinema_coinUnit: "koin",
  cinema_people: "orang",
  cinema_conversionStats: "Konversi referral",
  cinema_allDatesTotal: "Total semua tanggal",
  cinema_selectedDatesTotal: "Total tanggal yang dipilih",
  cinema_conversionStatsDesc: "Tampilan harian, pendaftaran, isi ulang, dan komisi",
  cinema_colDate: "Tanggal",
  cinema_colPv: "Pengunjung",
  cinema_colBrowseCount: "Tampilan",
  cinema_colRegister: "Pendaftaran",
  cinema_colRechargeUsers: "Pembayar",
  cinema_colRechargeOrders: "Pesanan",
  cinema_colPaidAmount: "Jumlah yang Dibayar",
  cinema_colCommission: "Komisi",
  cinema_colRegisterRate: "Tingkat Pendaftaran",
  cinema_colRechargeRate: "Tingkat Isi Ulang",
  cinema_commissionRateTitle: "Tingkat Komisi",
  cinema_currentRateLabel: "Tingkat komisi aktual saat ini",
  cinema_baseRate: "Tarif Dasar",
  cinema_currentRate: "Tarif Saat Ini",
  cinema_earningsRecord: "Catatan Penghasilan",
  cinema_inviteDetail: "Detail Undangan",
  cinema_allEarnings: "Semua Penghasilan",
  cinema_filterAll: "Semua",
  cinema_filterPending: "Menunggu",
  cinema_filterSettled: "Telah Ditetapkan",
  cinema_earningsDate: "Tanggal",
  cinema_earningsType: "Jenis",
  cinema_earningsUser: "Pengguna",
  cinema_earningsAmount: "Penghasilan",
  cinema_earningsStatus: "Status",
  cinema_statusSettled: "Telah Ditetapkan",
  cinema_statusPending: "Menunggu",
  cinema_noEarningsRecords: "Belum ada catatan",
  cinema_referralUser: "Pengguna",
  cinema_referralRegDate: "Terdaftar",
  cinema_referralRecharged: "Total Isi Ulang",
  cinema_referralEarned: "Penghasilan Saya",
  cinema_startDate: "Tanggal Mulai",
  cinema_endDate: "Tanggal Berakhir",
  cinema_query: "Cari",
  cinema_dateRangeError: "Tanggal mulai tidak boleh lebih dari tanggal berakhir",
  cinema_brand: "Huangguo TV",
  cinema_language: "Bahasa",
  cinema_tagline: "Drama pendek AI orisinal",
  cinema_navHome: "Beranda",
  cinema_navCategories: "Peringkat",
  cinema_rankingTitle: "Peringkat",
  cinema_rankingAll: "Semua",
  cinema_rankingLoading: "Memuat peringkat...",
  cinema_rankingStats: "{{scope}} · {{period}} · {{count}} serial · {{views}} tampilan",
  cinema_rankingTotal: "Sepanjang masa",
  cinema_rankingMonth: "Bulanan",
  cinema_rankingWeek: "Mingguan",
  cinema_rankingLatest: "Terbaru",
  cinema_rankingCreator: "Pembuat Konten",
  cinema_creatorLabel: "Pembuat Konten",
  cinema_rankingEmpty: "Belum ada serial berperingkat",
  cinema_navMyList: "Populer",
  cinema_soundGuideTitle: "Ketuk di sini untuk mengaktifkan suara",
  cinema_soundGuideAction: "Aktifkan suara",
  cinema_soundGuideDismiss: "Tutup panduan suara",
  cinema_navHistory: "Riwayat",
  cinema_navAds: "Koin",
  cinema_adsTitle: "Iklan Unggulan",
  cinema_adsSubtitle: "Temukan lebih banyak konten unggulan",
  cinema_adFeatured: "Unggulan",
  cinema_adOpen: "Lihat Sekarang",
  cinema_adsEmpty: "Tidak ada iklan yang tersedia",
  cinema_adsLoadFailed: "Tidak dapat memuat iklan. Silakan coba lagi.",
  cinema_earnTitle: "Dapatkan Koin",
  cinema_earnSubtitle: "Check-in setiap hari dan kumpulkan koin",
  cinema_earnBalance: "Koin Saya",
  cinema_checkInTitle: "Check-in Harian",
  cinema_checkInSubtitle: "Pertahankan rentetan Anda untuk mendapatkan lebih banyak koin",
  cinema_checkInDay: "Hari {{day}}",
  cinema_checkInToday: "Hari Ini",
  cinema_checkInClaim: "Check-in untuk {{points}} koin",
  cinema_checkInClaimed: "Sudah check-in hari ini",
  cinema_checkInLogin: "Masuk untuk check-in",
  cinema_checkInSuccess: "Check-in selesai. Anda telah mendapatkan {{points}} koin",
  cinema_checkInFailed: "Check-in gagal. Periksa koneksi Anda dan coba lagi",
  cinema_checkInNoReward: "Perangkat ini sudah menerima hadiah check-in hari ini",
  cinema_checkInStreak: "Rentetan saat ini",
  cinema_checkInStreakValue: "{{days}} hari",
  cinema_checkInTotal: "Total yang diperoleh",
  cinema_checkInTotalValue: "{{points}} koin",
  cinema_checkInLoadFailed: "Gagal memuat status check-in",
  cinema_retry: "Coba lagi",
  cinema_moreEarnWays: "Lebih banyak cara untuk mendapatkan",
  cinema_inviteEarnTitle: "Undang teman dan dapatkan",
  cinema_inviteEarnDesc: "Dapatkan koin saat teman mendaftar",
  cinema_goInvite: "Undang",
  cinema_earnCoinsTitle: "Dapatkan Koin",
  cinema_earnCoinsBalance: "Koin Saya",
  cinema_earnCoinsSignInStreak: "Anda telah check-in selama {{count}} hari",
  cinema_earnCoinsCheckIn: "Check In",
  cinema_earnCoinsCheckedIn: "Sudah Check In",
  cinema_earnCoinsTomorrow: "Kembali Besok",
  cinema_earnCoinsInviteTitle: "Undang teman untuk mendapatkan",
  cinema_earnCoinsInviteCode: "Kode Undangan Saya",
  cinema_earnCoinsGoInvite: "Undang Sekarang",
  cinema_earnCoinsLimitedTask: "Tugas Terbatas",
  cinema_earnCoinsTimeLeft: "Hitung Mundur",
  cinema_earnCoinsNewbieTask: "Tugas Pemula",
  cinema_earnCoinsDailyTask: "Tugas Harian",
  cinema_earnCoinsRecommendations: "Direkomendasikan",
  cinema_earnCoinsAdTask: "Tonton Iklan",
  cinema_earnCoinsAdTaskDesc: "Tonton iklan untuk mendapatkan lebih banyak koin",
  cinema_earnCoinsGoWatch: "Tonton Iklan",
  cinema_earnCoinsTaskReward: "+{{reward}}",
  cinema_earnCoinsDayLabel: "Hari {{day}}",
  cinema_earnCoinsToday: "Hari Ini",
  cinema_earnCoinsCoinUnit: "koin",
  cinema_earnCoinsAdCurrent: "Tugas Saat Ini",
  cinema_earnCoinsAdLocked: "Tugas Terkunci",
  cinema_earnCoinsTaskCompleted: "Selesai",
  cinema_limitedRechargeTaskTitle: "Selesaikan isi ulang pertama Anda dalam waktu 1 jam",
  cinema_limitedRechargeTaskAction: "Isi Ulang",
  cinema_claimReward: "Klaim",
  cinema_claiming: "Sedang Klaim",
  cinema_taskClaimFailed: "Klaim gagal. Silakan coba lagi.",
  cinema_bindEmailAction: "Hubungkan Email",
  cinema_limitedRechargeTaskExpired: "Kadaluarsa",
  cinema_watchHistory: "Riwayat Tontonan",
  cinema_navSearch: "Cari serial...",
  cinema_login: "Masuk",
  cinema_vip: "Isi saldo",
  cinema_heroPlay: "Mainkan Sekarang",
  cinema_heroMore: "Pelajari Lebih Lanjut",
  cinema_hotRecommend: "Sedang Tren",
  cinema_carouselLoading: "Memuat konten unggulan...",
  cinema_newRelease: "Rilis Baru",
  cinema_allSeries: "Semua Serial",
  cinema_viewAll: "Lihat Semua",
  cinema_episodes: "{{count}} Episode",
  cinema_rating: "Peringkat {{score}}",
  cinema_views: "{{count}} Penayangan",
  cinema_play: "Mainkan",
  cinema_continueWatch: "Lanjutkan Menonton",
  cinema_rewatch: "Tonton Ulang",
  cinema_categoryAll: "Semua",
  cinema_categoryUrban: "Romansa Urban",
  cinema_categorySuspense: "Suspensi",
  cinema_categoryCostume: "Sejarah",
  cinema_categoryWorkplace: "Tempat Kerja",
  cinema_categorySciFi: "Fiksi Ilmiah",
  cinema_categorySciFiRomance: "Romansa Fiksi Ilmiah",
  cinema_unlock: "Buka Kunci Episode",
  cinema_unlockDesc: "Membuka kunci episode ini membutuhkan {{cost}} koin",
  cinema_unlockConfirm: "Konfirmasi & Mainkan",
  cinema_cancel: "Batalkan",
  cinema_balance: "Saldo: {{coins}} koin",
  cinema_insufficient: "Koin tidak cukup, harap isi ulang",
  cinema_unlocked: "Telah Dibuka",
  cinema_locked: "Terkunci",
  cinema_episodeNumber: "Episode {{number}}",
  cinema_playing: "Sedang Diputar",
  cinema_backToList: "Kembali ke Daftar",
  cinema_back: "Kembali",
  cinema_noSeries: "Tidak ada serial yang tersedia",
  cinema_seriesDesc: "Sinopsis",
  cinema_episodeList: "Episode",
  cinema_nextEpisode: "Berikutnya",
  cinema_episodeEnded: "Episode Selesai",
  cinema_nextEpisodePrompt: "Lanjutkan dengan episode {{number}}?",
  cinema_playNextEpisode: "Mainkan Episode Berikutnya",
  cinema_prevEpisode: "Sebelumnya",
  cinema_freeLabel: "Gratis",
  cinema_vipLabel: "VIP",
  cinema_newLabel: "Baru",
  cinema_hotLabel: "Populer",
  cinema_featuredBanner: "Wajib Ditonton Minggu Ini",
  cinema_watchNow: "Tonton Sekarang",
  cinema_searchPlaceholder: "Cari drama",
  cinema_noResults: "Tidak ditemukan serial",
  cinema_emptyMyList: "Belum ada serial di daftar Anda",
  cinema_emptyHistory: "Tidak ada riwayat tontonan",
  cinema_addToMyList: "Tambahkan ke Daftar Saya",
  cinema_removeFromMyList: "Hapus dari Daftar Saya",
  cinema_clearAll: "Hapus Semua",
  cinema_footerCopy: "Huangguo TV — Platform Drama Pendek Premium",
  cinema_footerWarning: "Konten dibuat oleh AI untuk tujuan hiburan. Harap patuhi hukum setempat.",
  cinema_myList: "Daftar Saya",
  cinema_addedAt: "Ditambahkan {{date}}",
  cinema_expand: "Perluas",
  cinema_collapse: "Runtuhkan",
  cinema_historyAll: "Semua",
  cinema_historyUnfinished: "Belum Selesai",
  cinema_historyFinished: "Selesai",
  cinema_historyCount: "{{count}} rekaman",
  cinema_noHistoryFilter: "Tidak ada rekaman dalam kategori ini",
  cinema_finished: "Selesai",
  cinema_watchedFull: "Telah Diselesaikan",
  cinema_welcomeBack: "Selamat Datang Kembali",
  cinema_loginDesc: "Masuk untuk membuka lebih banyak konten",
  cinema_phoneLogin: "Masuk dengan Telepon",
  cinema_emailLogin: "Masuk dengan Email",
  cinema_phonePlaceholder: "Masukkan nomor telepon",
  cinema_emailPlaceholder: "Masukkan alamat email",
  cinema_agreeTerms: "Dengan masuk, Anda menyetujui",
  cinema_userAgreement: "Perjanjian Pengguna",
  cinema_privacyPolicy: "Kebijakan Privasi",
  cinema_getCode: "Dapatkan Kode",
  cinema_loginNow: "Masuk Sekarang",
  cinema_otherLogin: "Metode Masuk Lainnya",
  cinema_loggingIn: "Sedang masuk...",
  cinema_loginSuccess: "Login Berhasil",
  cinema_loginRedirect: "Mengarahkan ke profil...",
  cinema_profile: "Profil",
  cinema_memberLabel: "Anggota",
  cinema_dealerLabel: "Distributor",
  cinema_coinAmount: "{{count}} koin",
  cinema_profileAccount: "Akun",
  cinema_profileContent: "Konten",
  cinema_profileSettings: "Pengaturan",
  cinema_editProfile: "Edit Profil",
  cinema_myCoins: "Koin Saya",
  cinema_myPurchases: "Dibeli",
  cinema_downloads: "Unduhan",
  cinema_playbackSettings: "Pengaturan Pemutaran",
  cinema_notifications: "Notifikasi",
  cinema_cacheManage: "Manajemen Cache",
  cinema_about: "Hubungi Kami",
  cinema_contactUnavailable: "Layanan pelanggan tidak tersedia. Silakan coba lagi nanti.",
  cinema_watchedHours: "Jam Tonton",
  cinema_collectionCount: "Koleksi",
  cinema_logout: "Keluar",
  cinema_logoutConfirm: "Konfirmasi Keluar?",
  cinema_logoutConfirmDesc: "Anda perlu login kembali untuk menggunakan fitur lengkap",
  cinema_version: "Versi {{version}}",
  cinema_rechargeTitle: "Isi Ulang",
  cinema_rechargeSubtitle: "Pilih paket isi ulang",
  cinema_rechargeVpnWarning: "VPN atau proxy dapat memicu kontrol risiko pembayaran, sehingga mencegah halaman checkout terbuka atau menyebabkan pembayaran gagal.",
  cinema_rechargeVpnGuideTitle: "Matikan VPN Anda sebelum melakukan pembayaran",
  cinema_rechargeVpnInstruction: "Setelah mematikan VPN, klik tombol di bawah untuk melanjutkan dengan metode pembayaran yang Anda pilih.",
  cinema_rechargeVpnContinue: "VPN sudah dimatikan, lanjutkan ke pembayaran",
  cinema_rechargeRMB: "Isi Ulang RMB",
  cinema_rechargeUSDT: "Isi Ulang USDT",
  cinema_rechargeRecommended: "Rekomendasi",
  cinema_rechargeCoins: "Koin",
  cinema_rechargeBonus: "Bonus +{{points}}",
  cinema_rechargeCredited: "Dapatkan {{points}}",
  cinema_firstRechargeBannerTitle: "Bonus isi ulang pertama! Hadiah ekstra untuk setiap nominal",
  cinema_firstRechargeSelectedBonus: "+{{points}} koin",
  cinema_firstRechargeLimitedTitle: "Bonus isi ulang pertama terbatas",
  cinema_dailyRechargeLimitedTitle: "Bonus isi ulang terbatas",
  cinema_firstRechargeLimitedBonus: "Ekstra {{percent}}% untuk setiap nominal",
  cinema_rechargePayMethod: "Metode Pembayaran",
  cinema_rechargePay: "Bayar",
  cinema_rechargeNoPackages: "Saat ini tidak ada paket isi ulang yang tersedia",
  cinema_paymentUnavailable: "Pembayaran saat ini tidak tersedia. Silakan hubungi dukungan.",
  cinema_follow: "Ikuti",
  cinema_collect: "Kumpulkan",
  cinema_share: "Bagikan",
  cinema_loading: "Memuat...",
  cinema_favorites: "Favorit",
  cinema_emptyFavorites: "Belum ada serial favorit",
  cinema_emptyPurchases: "Belum ada serial yang dibeli",
  cinema_clearAllConfirm: "Hapus semua riwayat tontonan?",
  cinema_episodesUnit: "Episode",
  cinema_lastWatched: "Episode terakhir ditonton {{episode}}",
  cinema_purchasedEpisodes: "{{count}} episode telah dibuka",
  cinema_account: "Akun",
  cinema_accountName: "Nama tampilan",
  cinema_accountEmail: "Email",
  cinema_shareCode: "Bagikan kode",
  cinema_saveProfile: "Simpan profil",
  cinema_profileSaved: "Profil disimpan",
  cinema_profileSaveFailed: "Gagal menyimpan profil",
  cinema_accountInfo: "Informasi dasar",
  cinema_changePassword: "Ubah kata sandi",
  cinema_newPassword: "Kata sandi baru",
  cinema_confirmPassword: "Konfirmasi kata sandi baru",
  cinema_passwordHint: "Gunakan setidaknya 6 karakter",
  cinema_passwordMismatch: "Kata sandi tidak cocok",
  cinema_passwordSaved: "Kata sandi diperbarui",
  cinema_passwordSaveFailed: "Gagal memperbarui kata sandi",
  cinema_savePassword: "Simpan kata sandi",
  cinema_pointsBalance: "Saldo koin",
  cinema_coinLedger: "Buku besar koin",
  cinema_businessReference: "Referensi",
  cinema_emptyPointLogs: "Belum ada riwayat koin",
  cinema_pointLog_registerReward: "Hadiah pendaftaran",
  cinema_pointLog_appFirstLoginReward: "Hadiah login pertama di aplikasi",
  cinema_pointLog_inviteReward: "Hadiah undangan",
  cinema_pointLog_dailyCheckIn: "Hadiah check-in harian",
  cinema_pointLog_limitedRechargeTask: "Hadiah tugas isi ulang pertama terbatas",
  cinema_pointLog_emailBindingTask: "Hadiah tugas mengaitkan email",
  cinema_pointLog_dailyUnlockTask: "Hadiah tugas membuka episode harian",
  cinema_bindEmailTaskTitle: "Hubungkan Email",
  cinema_dailyUnlockTaskTitle: "Buka {{count}} episode baru",
  cinema_unlockAction: "Buka",
  cinema_dailyTaskProgress: "Progres hari ini {{current}}/{{target}} (Episode 1 tidak dihitung)",
  cinema_pointLog_firstEpisodeUnlock: "Buka kunci episode pertama",
  cinema_pointLog_episodeUnlock: "Buka kunci episode",
  cinema_pointLog_recharge: "Pulsa isi ulang telah dikreditkan",
  cinema_pointLog_firstRechargeBonus: "Bonus isi ulang pertama",
  cinema_pointLog_dailyRechargeBonus: "Bonus isi ulang terbatas",
  cinema_pointLog_adminAdjust: "Penyesuaian admin",
  cinema_pointLog_other: "Perubahan koin",
  cinema_pointBiz_register: "Pendaftaran",
  cinema_pointBiz_registerBackfill: "Pengisian kembali hadiah pendaftaran",
  cinema_pointBiz_appFirstLogin: "Login pertama di aplikasi",
  cinema_pointBiz_inviteRegister: "Pendaftaran melalui undangan",
  cinema_pointBiz_dailyCheckIn: "Check-in harian",
  cinema_pointBiz_legacyLimitedRechargeTask: "Tugas isi ulang 24 jam",
  cinema_pointBiz_limitedRechargeTask: "Tugas isi ulang pertama 1 jam",
  cinema_pointBiz_emailBindingTask: "Tugas pengikatan email",
  cinema_pointBiz_unlockThreeEpisodes: "Tugas buka kunci 3 episode harian",
  cinema_pointBiz_unlockFiveEpisodes: "Tugas buka kunci 5 episode harian",
  cinema_pointBiz_episodeUnlock: "Buka kunci episode",
  cinema_pointBiz_rechargeOrder: "Pesanan isi ulang",
  cinema_pointBiz_adminAdjust: "Penyesuaian admin",
  cinema_pointBiz_other: "Bisnis lainnya",
  cinema_playbackAutoplay: "Putar otomatis episode berikutnya",
  cinema_playbackAutoplayDesc: "Lanjutkan secara otomatis saat sebuah episode berakhir",
  cinema_aboutDesc: "My Fantasy menghadirkan konten drama pendek yang terus diperbarui.",
  cinema_rechargeOrders: "Buku besar isi ulang",
  cinema_myRechargeRecords: "Lihat riwayat isi ulang saya",
  cinema_totalInvites: "Total undangan",
  cinema_distributionStats: "Statistik promosi",
  cinema_distributionStatsDesc: "Telusuri kunjungan, pendaftaran, isi ulang, dan komisi berdasarkan tanggal",
  cinema_summaryDate: "Tanggal",
  cinema_summaryBrowse: "Jumlah tampilan",
  cinema_summaryRegister: "Jumlah pendaftaran",
  cinema_summaryRechargeCount: "Jumlah isi ulang",
  cinema_conversionRate: "Tingkat konversi",
  cinema_commissionRatio: "Rasio komisi",
  cinema_browseDetails: "Lihat detail",
  cinema_browseTime: "Waktu tampilan",
  cinema_browseDrama: "Drama",
  cinema_browseRegion: "Wilayah",
  cinema_noBrowseData: "Belum ada catatan tampilan",
  cinema_noSummaryData: "Belum ada data ringkasan",
  cinema_rewarded: "Diberi imbalan",
  cinema_registered: "Terdaftar",
  cinema_close: "Tutup",
  cinema_emptyRechargeOrders: "Belum ada catatan isi ulang",
  cinema_rechargeRecords: "Buku Besar Isi Ulang",
  cinema_commissionRecords: "Buku Besar Komisi",
  cinema_rechargeTime: "Waktu Isi Ulang",
  cinema_paymentMethod: "Metode Pembayaran",
  cinema_paymentStatus: "Status Pembayaran",
  cinema_orderNo: "Nomor Pesanan",
  cinema_noRechargeRecords: "Belum ada catatan isi ulang",
  cinema_commissionTime: "Waktu Komisi",
  cinema_commissionLevel: "Tingkat Komisi",
  cinema_commissionRate: "Tarif Komisi",
  cinema_noCommissionRecords: "Belum ada catatan komisi",
  cinema_search: "Cari",
  cinema_reset: "Atur Ulang",
  cinema_previousPage: "Sebelumnya",
  cinema_nextPage: "Berikutnya",
  cinema_paymentStatus_created: "Dibuat",
  cinema_paymentStatus_pending: "Menunggu pembayaran",
  cinema_paymentStatus_paid: "Isi ulang selesai",
  cinema_paymentStatus_failed: "Pembayaran gagal",
  cinema_paymentStatus_closed: "Ditutup",
  cinema_paymentStatus_expired: "Kedaluwarsa",
  cinema_paymentAwaiting: "Pesanan dibuat. Selesaikan pembayaran di halaman pembayaran. Jika gagal, pastikan VPN Anda telah dinonaktifkan.",
  cinema_usdtAddress: "Alamat penerima",
  cinema_usdtNetwork: "Hanya jaringan TRC20",
  cinema_copy: "Salin",
  cinema_copied: "Telah disalin",
  cinema_playerSettings: "Pengaturan pemutaran",
  cinema_playerQuality: "Kualitas",
  cinema_playerSpeed: "Kecepatan pemutaran",
  cinema_playerAuto: "Otomatis",
  cinema_playerSource: "Asli",
  cinema_playerSubtitles: "Subtitle",
  cinema_subtitleAuto: "Otomatis",
  cinema_subtitleOff: "Matikan subtitle",
  cinema_appDownloadTitle: "Tonton episode berikutnya dengan lebih andal di Aplikasi",
  cinema_appDownloadDesc: "Ingat kemajuan Anda dan dapatkan notifikasi tentang pembaruan.",
  cinema_appDownloadReward: "Unduh Aplikasi dan dapatkan {{points}} koin bonus pada login pertama Anda!",
  cinema_homeAppDownloadReward: "Dapatkan {{points}} koin bonus saat Anda masuk dengan Aplikasi!",
  cinema_shareEarnPoints: "Bagikan & Dapatkan",
  cinema_shareLinkLabel: "Bagikan tautan",
  cinema_shareRewardUnlimited: "Dapatkan {{points}} koin untuk setiap pengguna baru yang bergabung melalui tautan Anda, tanpa batas!",
  cinema_loginForShareLink: "Masuk untuk mendapatkan tautan referensi Anda",
  cinema_viewReferralStats: "Lihat Statistik Referensi",
  cinema_episodeFinished: "Episode Selesai",
  cinema_unlockNextEpisode: "Buka Episode Berikutnya",
  cinema_changeDrama: "Ganti Video",
  cinema_allUnlocked: "Semua Terbuka",
  cinema_appDownloadButton: "Unduh Aplikasi",
  cinema_appDownloadUnavailable: "Unduhan belum tersedia",
  cinema_rechargeAppPromptTitle: "Unduh Aplikasi untuk Mendapatkan Koin Bonus",
  cinema_rechargeAppPromptReward: "Unduh dan masuk untuk mendapatkan {{points}} koin ekstra!",
  cinema_rechargeAppPromptDesc: "Nikmati pemutaran yang lebih andal dan kemajuan menonton otomatis di Aplikasi.",
  cinema_appDownloadQr: "Pindai untuk mengunduh Aplikasi",
  cinema_ageGateBadge: "Verifikasi usia",
  cinema_ageGateTitle: "Peringatan Konten Dewasa",
  cinema_ageGateDescription: "Situs web ini berisi konten buatan AI fiksi yang ditujukan hanya untuk orang dewasa. Dengan melanjutkan, Anda menyatakan bahwa Anda berusia minimal 18 tahun dan setuju untuk mematuhi hukum di lokasi Anda.",
  cinema_ageGateUnderage: "Jika Anda berusia di bawah 18 tahun, harap tinggalkan situs web ini sekarang.",
  cinema_ageGateConfirm: "Saya berusia 18 tahun atau lebih — masuk ke situs web",
  cinema_creatorCenter: "Pusat Kreator",
  cinema_creatorCenterDesc: "Ciptakan cerita Anda, bagikan dunia Anda",
  cinema_creatorCenterNote: "Catatan: Karya non-asli harus bebas dari watermark",
  cinema_creatorMemberReady: "Anda adalah anggota VIP, ajukan dengan satu klik",
  cinema_creatorBecome: "Jadilah Kreator",
  cinema_creatorGateDesc: "Bawa cerita Anda ke Huangguo TV. Setelah disetujui, karya Anda akan tayang di bioskop untuk jutaan penonton, sehingga bakat Anda dapat dilihat dan Anda bisa mendapatkan bagian pendapatan langganan premium.",
  cinema_creatorApplyBtn: "Ajukan Permohonan Menjadi Kreator",
  cinema_creatorBenefitTitle: "Manfaat bagi Kreator",
  cinema_creatorBenefit1: "Karya Anda akan terdaftar dengan label \"Asli\" khusus",
  cinema_creatorBenefit2: "Pantau jumlah tampilan, langganan, dan pembagian pendapatan secara real-time",
  cinema_creatorBenefit3: "Buka lebih banyak alat kreasi dan sumber daya promosi",
  cinema_creatorReviewTip: "Permohonan dan karya akan ditinjau oleh platform dan harus mematuhi pedoman komunitas.",
  cinema_creatorLevel: "Kreator Terverifikasi",
  cinema_creatorOriginal: "Asli",
  cinema_creatorSince: "Kreator sejak",
  cinema_creatorAddWork: "Unggah Karya Baru",
  cinema_creatorTabOverview: "Ikhtisar",
  cinema_creatorTabWorks: "Karya Saya",
  cinema_creatorTabUpload: "Unggah",
  cinema_creatorTabPlatform: "Studio",
  cinema_creatorSubmitted: "Telah dikirim, menunggu peninjauan",
  cinema_creatorStatViews: "Total Tampilan",
  cinema_creatorStatSubs: "Total Pelanggan",
  cinema_creatorStatRevenue: "Total Pendapatan",
  cinema_creatorStatWithdraw: "Dapat Ditarik",
  cinema_creatorStatWorks: "Karya",
  cinema_creatorStatReview: "Sedang Ditinjau",
  cinema_creatorStatRejected: "Ditolak",
  cinema_creatorTopWork: "Karya dengan Kinerja Terbaik",
  cinema_creatorViews: "Tampilan",
  cinema_creatorSubscriptions: "Pelanggan",
  cinema_creatorShare: "Pendapatan",
  cinema_creatorNoPublished: "Belum ada karya yang dipublikasikan",
  cinema_creatorFilterPublished: "Dipublikasikan",
  cinema_creatorFilterReview: "Sedang Ditinjau",
  cinema_creatorFilterRejected: "Ditolak",
  cinema_creatorWorksTitle: "Karya Saya",
  cinema_creatorNoWorks: "Belum ada karya, unggah karya pertama Anda",
  cinema_creatorGoUpload: "Unggah Sekarang",
  cinema_creatorStatusPublished: "Dipublikasikan",
  cinema_creatorStatusReview: "Sedang Ditinjau",
  cinema_creatorStatusApproved: "Menunggu Transkoding",
  cinema_creatorStatusTranscoding: "Sedang Ditranskod",
  cinema_creatorStatusReady: "Menunggu Publikasi",
  cinema_creatorStatusTranscodeFailed: "Transkoding Gagal",
  cinema_creatorStatusPublishFailed: "Publikasi Gagal",
  cinema_creatorStatusRejected: "Ditolak",
  cinema_creatorPublishedOn: "Dipublikasikan pada",
  cinema_creatorSubmittedOn: "Telah dikirim pada",
  cinema_creatorRejectedTip: "Ditolak · Telah dikirim pada",
  cinema_creatorWorkName: "Judul Karya",
  cinema_creatorWorkNamePh: "Masukkan judul karya",
  cinema_creatorCategory: "Kategori",
  cinema_creatorCover: "Sampul",
  cinema_creatorCoverHint: "Unggah satu gambar sampul potret",
  cinema_creatorCoverUrlPh: "Tempelkan tautan gambar (opsional)",
  cinema_creatorSynopsis: "Sinopsis",
  cinema_creatorSynopsisPh: "Jelaskan cerita Anda dalam satu atau dua kalimat…",
  cinema_creatorEpisodeTitle: "Episode",
  cinema_creatorEpisodeDesc: "Tambahkan judul dan unggah satu video MP4 untuk setiap episode",
  cinema_creatorEpisodeTitlePh: "Judul episode",
  cinema_creatorEpisodeDurPh: "Durasi (menit)",
  cinema_creatorAddEpisode: "Tambahkan Episode",
  cinema_creatorEpShort: "Ep {{count}}",
  cinema_creatorEpisodeUpload: "Unggah MP4",
  cinema_creatorEpisodeUploading: "Sedang mengunggah…",
  cinema_creatorEpisodeReplace: "Ganti video",
  cinema_creatorEpisodeMp4Only: "Hanya file .mp4, maksimal 100 MB per file",
  cinema_creatorEpisodeTypeError: "Setiap episode harus berupa video .mp4",
  cinema_creatorEpisodeSizeError: "Ukuran video setiap episode tidak boleh lebih dari 100 MB",
  cinema_creatorEpisodeUploadFailed: "Pengunggahan episode gagal. Silakan coba lagi.",
  cinema_creatorEpisodeRequired: "Tambahkan judul dan unggah video MP4 untuk setiap episode",
  cinema_creatorRequired: "Harap isi judul dan pilih sampul terlebih dahulu",
  cinema_creatorWorkNameRequired: "Masukkan judul karya",
  cinema_creatorCategoryRequired: "Pilih kategori",
  cinema_creatorCoverRequired: "Unggah gambar sampul",
  cinema_creatorEpisodeTitleRequired: "Masukkan judul episode",
  cinema_creatorEpisodeVideoRequired: "Unggah video MP4 untuk episode ini",
  cinema_creatorSubmit: "Kirim untuk Ditinjau",
  cinema_creatorPlatformTag: "Direkomendasikan Pembuat Konten",
  cinema_creatorPlatformTitle: "Platform Alat Kreasi",
  cinema_creatorPlatformDesc: "Kunjungi platform kreasi resmi untuk alat profesional, inspirasi naskah, dan aset guna mewujudkan cerita Anda serta menerbitkannya.",
  cinema_creatorPlatformPoint1: "Naskah & Ide AI",
  cinema_creatorPlatformPoint2: "Alat Kreasi & Unggah Profesional",
  cinema_creatorPlatformPoint3: "Dukungan Lalu Lintas & Pembayaran",
  cinema_creatorPlatformOpen: "Pergi ke Platform Kreasi",
  cinema_creatorEarnBannerTitle: "Bawa Cerita Anda ke Layar Lebar",
  cinema_creatorEarnBannerDesc: "Jadilah pembuat konten, unggah karya, dan dapatkan penghasilan dari tayangan, langganan, serta bagi hasil",
  cinema_creatorEarnBannerBtn: "Buka Pusat Pembuat Konten",
  cinema_creatorApplyFailed: "Pengajuan gagal. Silakan coba lagi.",
  cinema_creatorSubmitFailed: "Pengiriman gagal. Silakan coba lagi.",
  cinema_creatorSubmitting: "Sedang mengirim…",
  cinema_creatorCategoryEmpty: "Tidak ada kategori yang tersedia",
  cinema_creatorCoverUpload: "Unggah sampul",
  cinema_creatorCoverUploading: "Sedang mengunggah…",
  cinema_creatorCoverChoose: "Pilih gambar",
  cinema_creatorCoverReplace: "Ganti gambar",
  cinema_creatorCoverRemove: "Hapus",
  cinema_creatorCoverFormat: "JPG, PNG, WebP atau GIF, hingga 10 MB. Hanya satu gambar.",
  cinema_creatorCoverTypeError: "Pilih gambar JPG, PNG, WebP atau GIF",
  cinema_creatorCoverSizeError: "Gambar sampul tidak boleh lebih besar dari 10 MB",
  cinema_creatorCoverUploadFailed: "Pengunggahan gambar sampul gagal. Silakan coba lagi.",
  cinema_creatorUploadNoticeTitle: "Panduan Unggahan",
  cinema_creatorUploadNotice1: "Semua sumber daya yang diunggah, baik asli maupun hasil modifikasi, harus bebas dari watermark.",
  cinema_creatorUploadNotice2: "Pembuat asli dapat menghubungi tim bisnis kami untuk mendaftarkan kepemilikan hak cipta.",
  cinema_creatorUploadNotice3: "Harga episode terakhir ditentukan oleh platform.",
  cinema_creatorUploadNotice4: "Setiap episode harus berdurasi minimal 150 detik.",
  cinema_creatorUploadNoticeConfirm: "Saya mengerti, lanjutkan",
  cinema_navProfile: "Saya",
};
